// Different School Email Extensions list
import { asu_valid_email_extensions } from '../utils/valid_email_extensions/asu_valid_email_extensions';
import { duke_valid_email_extensions } from '../utils/valid_email_extensions/duke_valid_email_extensions';
import { fsu_valid_email_extensions } from '../utils/valid_email_extensions/fsu_valid_email_extensions';
import { harvard_valid_email_extensions } from '../utils/valid_email_extensions/harvard_valid_email_extensions';
import { lsu_valid_email_extensions } from '../utils/valid_email_extensions/lsu_valid_email_extensions';
import { mit_valid_email_extensions } from '../utils/valid_email_extensions/mit_valid_email_extensions';
import { nyu_valid_email_extensions } from '../utils/valid_email_extensions/nyu_valid_email_extensions';
import { okstate_valid_email_extensions } from '../utils/valid_email_extensions/okstate_valid_email_extensions';
import { olemiss_valid_email_extensions } from '../utils/valid_email_extensions/olemiss_valid_email_extensions';
import { osu_valid_email_extensions } from '../utils/valid_email_extensions/osu_valid_email_extensions';
import { ou_valid_email_extensions } from '../utils/valid_email_extensions/ou_valid_email_extensions';
import { smu_valid_email_extensions } from '../utils/valid_email_extensions/smu_valid_email_extensions';
import { stanford_valid_email_extensions } from '../utils/valid_email_extensions/stanford_valid_email_extensions';
import { tamu_valid_email_extensions } from '../utils/valid_email_extensions/tamu_valid_email_extensions';
import { ucf_valid_email_extensions } from '../utils/valid_email_extensions/ucf_valid_email_extensions';
import { ucla_valid_email_extensions } from '../utils/valid_email_extensions/ucla_valid_email_extensions';
import { uf_valid_email_extensions } from '../utils/valid_email_extensions/uf_valid_email_extensions';
import { uk_valid_email_extensions } from '../utils/valid_email_extensions/uk_valid_email_extensions';
import { unt_valid_email_extensions } from '../utils/valid_email_extensions/unt_valid_email_extensions';
import { ut_valid_email_extensions } from '../utils/valid_email_extensions/ut_valid_email_extensions';

import { 
    SET_PAGE, 
    TOGGLE_USER_MODAL,
    TOGGLE_PROFILE_MODAL,
    TOGGLE_CREATE_GROUP_MODAL,
    TOGGLE_CREATE_MATCH_MODAL,
    TOGGLE_AUTH_MODAL,
    TOGGLE_PRIVACY_MODAL,
    TOGGLE_MESSAGE_MODAL,
    SET_AUTH_MODAL,
    SET_PRIVACY_MODAL,
    TOGGLE_VERIFY_MODAL,
    TOGGLE_VERIFY_SCHOOL_MODAL,
    SET_PROFILE_MODAL,
    TOGGLE_POST_MODAL,
    SET_POST_MODAL,
    TOGGLE_COMMENT_MODAL,
    SET_COMMENT_MODAL,
    TOGGLE_SHARE_MODAL,
    SET_NAV1, 
    REMOVE_NAV1, 
    SET_NAV2, 
    REMOVE_NAV2, 
    SET_NAV3, 
    REMOVE_NAV3, 
    SET_MAIN_NAV,
    TOGGLE_SIDE_NAV,
    TOGGLE_ITEM_MODAL, 
    TOGGLE_COLLECTION_MODAL, 
    TOGGLE_LOCATION_MODAL, 
    REMOVE_ITEM_MODAL, 
    REMOVE_COLLECTION_MODAL, 
    REMOVE_LOCATION_MODAL,  
    SET_SCROLL_TO_TOP,
    // Marketplace 
    SET_IS_MARKETPLACE,

    // Driver Portal
    TOGGLE_QUIT_DELIV_MODAL,
    TOGGLE_START_DELIV_MODAL,
    TOGGLE_CONFIRM_PICKUP_MODAL,
    TOGGLE_CUSTOMER_CODE_MODAL,
    GET_WEBSITE,
    CLEAR_WEBSITE,
    SET_COUNTRY_CODE,
    SET_CONTINENT_NAME,
    SET_FIREWALL
} from '../actions/types';

const initialState = {
    // CUSTOM URL Logic
    website: null,
    website_loading: true,
    valid_Email_Exts: [],
   // Navigation state
    nav1: '', // Navigation state for level 1
    nav2: '', // Navigation state for level 2
    nav3: '', // Navigation state for level 3
    page: '', // Current page being displayed
    main: '', // Main navigation state
    scroll_to_top: false,

    // Modal states
    userModal: false, // User modal state
    profileModal: false, // Profile modal state
    postModal: false, // Post modal state
    commentModal: false, // Comment modal state
    authModal: false, // Authentication modal state
    privacyModal: false,
    messageModal: false,
    verify_Modal: false,
    verifySchool_Modal: false,
    authModalType: '', // Type of authentication modal being displayed
    privacyModalType: '',
    itemModal: false, // Item modal state
    collectionModal: false, // Collection modal state
    locationModal: false, // Location modal state
    createGroupModal: false, // Create Group Modal  state
    createSportsMatchModal: false, // Create Sports Match Modal  state

    // Other state
    sideNav: false, // State of the side navigation
    loading: true, // Loading state

    // Marketplace
    isMarketplace: false,

    // Driver Portal
    driver_quitDeliveryModal: false, // Quit Delivery modal state
    driver_startDeliveryModal: false, // Start Delivery modal state
    driver_confirmPickupModal: false, // Confirm Pickup modal state
    driver_customerCodeModal: false, // Customer Code modal state

    // Security Logic
    country_code: '',
    continent_name: '',
    show_firewall: false,
    geo_loading: true
}

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case SET_SCROLL_TO_TOP: {

            // Set the scroll_to_top state to the payload value
            return {
                ...state,
                scroll_to_top: payload
            };
        }
        case SET_PAGE: {

            // Set the page state to the payload value
            return {
                ...state,
                page: payload,
                loading: false
            };
        }
        case SET_IS_MARKETPLACE: 

            return {
                ...state,
                isMarketplace: payload
            }
        case TOGGLE_USER_MODAL: 

            // Toggle the userModal state between open and closed
            return {
                ...state,
                userModal: !state.userModal
            }
        case TOGGLE_PROFILE_MODAL: 

            // Toggle the profileModal state between open and closed
            return {
                ...state,
                profileModal: !state.profileModal
            }
        case TOGGLE_CREATE_GROUP_MODAL: 

            // Toggle the profileModal state between open and closed
            return {
                ...state,
                createGroupModal: !state.createGroupModal
            }
        case TOGGLE_CREATE_MATCH_MODAL: 

            // Toggle the modal state between open and closed
            return {
                ...state,
                createSportsMatchModal: !state.createSportsMatchModal
            }
        case TOGGLE_POST_MODAL: 

            // Toggle the postModal state between open and closed
            return {
                ...state,
                postModal: !state.postModal
            }
        case SET_POST_MODAL: 

            // Set the postModal state to the payload value
            return {
                ...state,
                postModal: payload
            }
        case TOGGLE_COMMENT_MODAL: 

             // Toggle the commentModal state between open and closed
            return {
                ...state,
                commentModal: !state.commentModal
            }
        case SET_COMMENT_MODAL: 

            // Set the commentModal state to the payload value
            return {
                ...state,
                commentModal: payload
            }
        case TOGGLE_AUTH_MODAL: 

            // Toggle the authModal state between open and closed and set the authModalType to the payload value
            return {
                ...state,
                authModal: !state.authModal,
                authModalType: payload
            }
        case TOGGLE_PRIVACY_MODAL: 

            // Toggle the privacyModal state between open and closed and set the privacyModalType to the payload value
            return {
                ...state,
                privacyModal: !state.privacyModal,
                privacyModalType: payload
            }
        case TOGGLE_MESSAGE_MODAL: 

            // Toggle the messageModal state between open and closed
            return {
                ...state,
                messageModal: !state.messageModal,
            }
        case SET_AUTH_MODAL: 

            // Set the authModal to the payload value
            return {
                ...state,
                authModal: payload,
            }
        case SET_PRIVACY_MODAL: 

            // Set the privacyModal to the payload value
            return {
                ...state,
                privacyModal: payload,
            }
        case TOGGLE_VERIFY_MODAL: 

            // Toggle the verify_Modal state between open and closed and set the authModalType to the payload value
            return {
                ...state,
                verify_Modal: !state.verify_Modal,
                authModalType: payload
            }
        case TOGGLE_VERIFY_SCHOOL_MODAL: 

            // Toggle the verify_Modal state between open and closed and set the authModalType to the payload value
            return {
                ...state,
                verifySchool_Modal: !state.verifySchool_Modal,
                authModalType: payload
            }
        case SET_PROFILE_MODAL: 

            // Set the profileModal state to the payload value
            return {
                ...state,
                profileModal: payload
            }
        case TOGGLE_SHARE_MODAL: 

            // Toggle the shareModal state between open and closed
            return {
                ...state,
                shareModal: !state.shareModal
            }
        case SET_MAIN_NAV: {

            // Set the main navigation state to the payload value
            return {
                ...state,
                main: payload,
                loading: false
            };
        }
        case SET_NAV1: {

            // Set the nav1 state to the payload value and reset nav2 and nav3
            return {
                ...state,
                nav1: payload,
                nav2: '',
                nav3: ''
            };
        }
        case SET_NAV2: {

            // Set the nav2 state to the payload value
            return {
                ...state,
                nav2: payload
            };
        }
        case SET_NAV3: {

            // Set the nav3 state to the payload value
            return {
                ...state,
                nav3: payload
            };
        }
        case REMOVE_NAV1: {

            // Remove the nav1 state
            return {
                ...state,
                nav3: ''
            };
        }
        case REMOVE_NAV2: {

            // Remove the nav2 state
            return {
                ...state,
                nav3: ''
            };
        }
        case REMOVE_NAV3: {

            // Remove the nav3 state
            return {
                ...state,
                nav3: ''
            };
        }
        case TOGGLE_SIDE_NAV: 

            // Toggle the sideNav state between open and closed
            return {
                ...state,
                sideNav: !state.sideNav
            }
        case TOGGLE_ITEM_MODAL:
            
            // Set the itemModal state to true
            return {
                ...state,
                itemModal: true
            }
        case TOGGLE_COLLECTION_MODAL: 

            // Set the collectionModal state to true
            return {
                ...state,
                collectionModal: true
            }
        case TOGGLE_LOCATION_MODAL: 

            // Set the locationModal state to true
            return {
                ...state,
                locationModal: !state.locationModal
            }
        case REMOVE_ITEM_MODAL: 

            // Remove the itemModal state
            return {
                ...state,
                itemModal: false
            }
        case REMOVE_COLLECTION_MODAL: 

            // Remove the collectionModal state
            return {
                ...state,
                collectionModal: false
            }
        case REMOVE_LOCATION_MODAL: 

            // Remove the locationModal state
            return {
                ...state,
                locationModal: false
            }

        // ---- DRIVER PORTAL ----
        
        case TOGGLE_QUIT_DELIV_MODAL: 

            // Toggle the driver_quitDeliveryModal state between open and closed
            return {
                ...state,
                driver_quitDeliveryModal: !state.driver_quitDeliveryModal
            }
        case TOGGLE_START_DELIV_MODAL: 

            // Toggle the driver_startDeliveryModal state between open and closed
            return {
                ...state,
                driver_startDeliveryModal: !state.driver_startDeliveryModal
            }
        case TOGGLE_CONFIRM_PICKUP_MODAL: 

            // Toggle the driver_confirmPickupModal state between open and closed
            return {
                ...state,
                driver_confirmPickupModal: !state.driver_confirmPickupModal
            }
        case TOGGLE_CUSTOMER_CODE_MODAL: 

            // Toggle the driver_customerCodeModal state between open and closed
            return {
                ...state,
                driver_customerCodeModal: !state.driver_customerCodeModal
            }
        case GET_WEBSITE: 

            const website_short_name = payload?.short_name?.toLowerCase();

            let valid_Extensions = [];
            
            if(website_short_name === 'ou') { // (OU)  University of Oklahoma
        
                valid_Extensions = ou_valid_email_extensions;

            } else if(website_short_name === 'smu') { // (SMU) Southern Methodist University

                valid_Extensions = smu_valid_email_extensions;

            } else if(website_short_name === 'ut') { // (UT)  University of Texas
                
                valid_Extensions = ut_valid_email_extensions;

            } else if(website_short_name === 'uf') { // (UF)  Univeristy of Florida

                valid_Extensions = uf_valid_email_extensions;

            } else if(website_short_name === 'ucla') { // (UCLA) University of California, Los Angeles

                valid_Extensions = ucla_valid_email_extensions;

            } else if(website_short_name === 'stanford') { // Stanford Univeristy (Stanford)

                valid_Extensions = stanford_valid_email_extensions;

            } else if(website_short_name === 'duke') { // Duke Univeristy (Duke)

                valid_Extensions = duke_valid_email_extensions;
                
            } else if(website_short_name === 'tamu') { // Texas A&M Univeristy (TAMU)

                valid_Extensions = tamu_valid_email_extensions;
                
            } else if(website_short_name === 'okstate') { // Oklahoma State Univeristy (Okstate)

                valid_Extensions = okstate_valid_email_extensions;
                
            } else if(website_short_name === 'ucf') { // Univeristy of Central Florida (UCF)

                valid_Extensions = ucf_valid_email_extensions;
                
            } else if(website_short_name === 'fsu') { // Florida State Univeristy (FSU)

                valid_Extensions = fsu_valid_email_extensions;
                
            } else if(website_short_name === 'unt') { // Univeristy of North Texas (UNT)

                valid_Extensions = unt_valid_email_extensions;
                
            } else if(website_short_name === 'mit') { // Massachusetts Institute of Technology (MIT)

                valid_Extensions = mit_valid_email_extensions;
                
            } else if(website_short_name === 'harvard') { // Harvard Univeristy (Harvard)

                valid_Extensions = harvard_valid_email_extensions;
                
            } else if(website_short_name === 'uk') { 
        
                valid_Extensions = uk_valid_email_extensions;
                
            } else if(website_short_name === 'olemiss') { 

                valid_Extensions = olemiss_valid_email_extensions;
                
            } else if(website_short_name === 'osu') {

                valid_Extensions = osu_valid_email_extensions;
                
            } else if(website_short_name === 'lsu') { 

                valid_Extensions = lsu_valid_email_extensions;
                
            } else if(website_short_name === 'nyu') { 

                valid_Extensions = nyu_valid_email_extensions;
                
            } else if(website_short_name === 'asu') { 

                valid_Extensions = asu_valid_email_extensions;
                
            }

            // --- Set browser tab's title & favicon ---
            
            if(payload?.short_name) {
                document.title = `${payload?.short_name} Buy / Sell`;
            }
    
            if (payload?.website_logo || payload?.website_favicon) {
                // Find the existing favicon link element
                let link = document.querySelector("link[rel~='icon']");
                
                // If it doesn't exist, create a new one
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                
                // Update the tab icon's source path
                link.href = payload?.website_favicon || payload?.website_logo;
                link.type = 'image/png'; 
            }

            // --- END: Set browser tab's title & favicon ---

            // Update state with modal user data
            return {
                ...state,
                website: payload,
                website_loading: false,
                valid_Email_Exts: valid_Extensions
            };
        case CLEAR_WEBSITE:

            // Clear modal user data
            return {
                ...state,
                website: null
            }
        case SET_COUNTRY_CODE: 

            // Set the current Country Code of the user IP

            return {
                ...state,
                country_code: payload,
                geo_loading: false
            }
        case SET_CONTINENT_NAME: 

            // Set the current Continent Code of the user IP

            return {
                ...state,
                continent_name: payload,
                geo_loading: false
            }
        case SET_FIREWALL: 

            // Set the current Country Code of the user IP

            return {
                ...state,
                show_firewall: payload,
            }
        default:
            return state;
    }
}